import React, { useState, useEffect } from "react";
import "./DashboardAgendamiento.css";
import CalendarView from "./ComponentsAgendamiento/CalendarView";
import ModalCita from "./ComponentsAgendamiento/ComponentsCalendarView/ModalCita";  
import HorarioAtencionModal from "./ComponentsAgendamiento/ComponentsCalendarView/HorarioAtencionModal";
import ModalPersonasAgenda from "./ComponentsAgendamiento/ComponentsCalendarView/ModalPersonasAgenda";
import { getCitas, getRecordatoriosPendientes, marcarRecordatorioEnviado, getTextoFicha, getDuplicados } from "../../../services/citas";
import { useNavigate, useLocation } from "react-router-dom";
import { getHistoriaClinicaPorPaciente } from "../../../services/historiaClinica";
import { toast } from "react-toastify";
import { getPerfilMedico } from "../../../services/usuarios";

const DashboardAgendamiento = () => {
    const [refresh, setRefresh] = useState(false);
    const [activeView, setActiveView] = useState(
  window.innerWidth <= 1024 ? "day" : "week"
);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [mostrarModal, setMostrarModal] = useState(false);
    const [mostrarModalConfig, setMostrarModalConfig] = useState(false);
    const [citaSeleccionada, setCitaSeleccionada] = useState(null);
    const [citasDelDia, setCitasDelDia] = useState([]);
    const [recordatoriosPendientes, setRecordatoriosPendientes] = useState([]);
      // Link público de citas: disponible = permiso de Salvir, habilitado = switch del médico
    const [linkCitas, setLinkCitas] = useState({ disponible: false, habilitado: false, slug: "" });
        // Personas de mi agenda: aviso de duplicados y modal
    const [duplicadosPendientes, setDuplicadosPendientes] = useState(0);
    const [mostrarPersonas, setMostrarPersonas] = useState(false);
    const [pestanaPersonas, setPestanaPersonas] = useState("duplicados");
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth <= 1024) {
      setActiveView((prev) => (prev === "week" ? "day" : prev));
    }
  };

  handleResize();

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

    useEffect(() => {
    if (location.state?.abrirConfigAgenda) {
        setMostrarModalConfig(true);

        // Limpia el state para que no se vuelva a abrir si refrescas/navegas raro
        navigate(location.pathname, { replace: true, state: {} });
    }
    }, [location.state, location.pathname, navigate]);
    
    const onDateChange = (date) => {
        setSelectedDate(date);
    };

    // 📌 Nueva función para abrir modal desde el botón de "Nueva Cita"
    const abrirModalNuevaCita = () => {
        const localDate = selectedDate.toISOString().split("T")[0]; // Formato YYYY-MM-DD
        setCitaSeleccionada({ fecha: localDate, start_time: "", end_time: "", motivo: "" });
        setMostrarModal(true);
    };

    // 📌 Obtener y organizar citas del día
    const fetchCitas = async () => {
        try {
            const citas = await getCitas();
            const hoy = new Date();
            const fechaHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}-${String(hoy.getDate()).padStart(2, "0")}`;
            let citasFiltradas = citas.filter(cita => cita.fecha === fechaHoy);

            // 📌 Ordenar por hora (de menor a mayor)
            citasFiltradas.sort((a, b) => {
                if (!a.start_time) return 1; // Si no tiene hora, mover al final
                if (!b.start_time) return -1;
                return a.start_time.localeCompare(b.start_time);
            });

            setCitasDelDia(citasFiltradas);
        } catch (error) {
            console.error("Error al obtener citas:", error);
            setCitasDelDia([]);
        }
    };

    const fetchRecordatoriosPendientes = async () => {
        try {
            const recordatorios = await getRecordatoriosPendientes();
            setRecordatoriosPendientes(recordatorios || []);
        } catch (error) {
            console.error("Error al obtener recordatorios pendientes:", error);
            setRecordatoriosPendientes([]);
        }
    };
    
    
    const fetchLinkCitas = async () => {
        try {
            const perfil = await getPerfilMedico();
            setLinkCitas({
                disponible: !!perfil?.autoagendamiento_disponible,
                habilitado: !!perfil?.autoagendamiento_habilitado,
                slug: perfil?.booking_slug || "",
            });
        } catch {
            setLinkCitas({ disponible: false, habilitado: false, slug: "" });
        }
    };

    const fetchDuplicados = async () => {
        const pares = await getDuplicados();
        setDuplicadosPendientes((pares || []).length);
    };

    const abrirPersonas = (pestana) => {
        setPestanaPersonas(pestana);
        setMostrarPersonas(true);
    };

    // 🔥 Se ejecuta cuando cambia `refresh`
    useEffect(() => {
        fetchCitas();
        fetchRecordatoriosPendientes();
        fetchLinkCitas();
        fetchDuplicados();
    }, [refresh]);

    // Botón de inicio de consulta
    const handleIniciarConsulta = async (pacienteId) => {
        try {
            const historiaClinica = await getHistoriaClinicaPorPaciente(pacienteId);

            if (!historiaClinica || !historiaClinica.id) {
                navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
                return;
            }

            if (historiaClinica.fecha_consulta) {
                navigate(`/dashboard/consulta-seguimiento/${pacienteId}`);
            } else {
                navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
            }
        } catch (error) {
            console.error("Error al obtener historia clínica:", error);
            if (error.response && error.response.status === 404) {
                navigate(`/dashboard/alta-historia-clinica/${pacienteId}`);
            } else {
                alert("No se pudo obtener la historia clínica. Intenta de nuevo.");
            }
        }
    };

   const normalizarTelefonoWhatsApp = (telefono) => {
    if (!telefono) return null;

    const soloNumeros = String(telefono).replace(/\D/g, "");

    if (soloNumeros.length !== 10) {
        return null;
    }

    return `52${soloNumeros}`;
};

const handleEnviarWhatsApp = async (recordatorio) => {
    const telefono = normalizarTelefonoWhatsApp(recordatorio.telefono_destino);

    if (!telefono) {
        toast.error("El teléfono del paciente no es válido. Debe tener 10 dígitos.");
        return;
    }

        // Si a esta persona le toca ficha, se crea el link y se pega al final del mensaje
    const textoFicha = await getTextoFicha(recordatorio.cita_id);
    const mensajeBase = recordatorio.mensaje || "Le recordamos que tiene una cita programada.";

    const mensaje = encodeURIComponent(
        textoFicha ? `${mensajeBase}\n\n${textoFicha}` : mensajeBase
    );

    window.open(`https://wa.me/${telefono}?text=${mensaje}`, "_blank");

    // Si ya estaba enviado, solo reabrimos WhatsApp. No hace falta tocar backend.
    if (recordatorio.status === "enviado") {
        return;
    }

    const actualizado = await marcarRecordatorioEnviado(recordatorio.id);

    if (actualizado) {
        setRecordatoriosPendientes((prev) =>
            prev.map((r) =>
                r.id === recordatorio.id
                    ? { ...r, status: "enviado" }
                    : r
            )
        );
    } else {
        alert("Se abrió WhatsApp, pero no se pudo marcar el recordatorio como enviado.");
    }
};


    const tieneLinkActivo = linkCitas.habilitado && !!linkCitas.slug;

    const handleLinkCitas = async () => {
        // Sin link activo: abre el engrane para que lo prenda
        if (!tieneLinkActivo) {
            setMostrarModalConfig(true);
            return;
        }

        const link = `${window.location.origin}/agendar/${linkCitas.slug}`;
        try {
            await navigator.clipboard.writeText(link);
            toast.success("Link copiado. Ya puedes compartirlo con tus pacientes.");
        } catch {
            window.prompt("Copia tu link:", link);
    }
};

    return (
        <div className="agendamiento-layout">
            <div className="agendamiento-header">
                <h2>Agendamiento de Citas</h2>
                <div className="agenda-top-actions">
                    <select
                        className="agenda-view-select"
                        value={activeView}
                        onChange={(e) => setActiveView(e.target.value)}
                    >
                       {window.innerWidth > 1024 && <option value="week">Semana</option>}
                        <option value="day">Día</option>
                        <option value="month">Mes</option>
                    </select>

                    <button className="btn-new-appointment" onClick={abrirModalNuevaCita}>
                        Nueva Cita
                    </button>

                                      {linkCitas.disponible && (
                        tieneLinkActivo ? (
                            <div
                                className="agenda-link-pill"
                                title="Comparte este link para que tus pacientes agenden en línea"
                            >
                                <span className="agenda-link-pill__label">
                                    🔗 Tu link para que tus pacientes agenden:
                                </span>
                                <span className="agenda-link-pill__url">
                                    {window.location.host}/agendar/<strong>{linkCitas.slug}</strong>
                                </span>
                                <button
                                    type="button"
                                    className="agenda-link-pill__copiar"
                                    onClick={handleLinkCitas}
                                >
                                    Copiar
                                </button>
                            </div>
                        ) : (
                            <button
                                className="btn-new-appointment agenda-link-button"
                                onClick={handleLinkCitas}
                                title="Activa tu página para que tus pacientes agenden en línea"
                            >
                                🔗 Activa tu link de citas
                            </button>
                        )
                    )}
                     <button
                        className="agenda-config-button"
                        onClick={() => abrirPersonas(duplicadosPendientes > 0 ? "duplicados" : "sin-alta")}
                        title="Personas de mi agenda"
                        aria-label="Personas de mi agenda"
                    >
                        👥
                    </button>
                    <button
                        className="agenda-config-button"
                        onClick={() => setMostrarModalConfig(true)}
                        title="Configurar horario de atención"
                        aria-label="Configurar horario de atención"
                    >
                        ⚙️
                    </button>
                </div>
            </div>

            <div className="agendamiento-body">
                <div className="calendar-section">
                    
                   <CalendarView
                        selectedDate={selectedDate}
                        onDateChange={onDateChange}
                        view={activeView}
                        setActiveView={setActiveView}
                        setMostrarModal={setMostrarModal}
                        setCitaSeleccionada={setCitaSeleccionada}
                        refresh={refresh}
                        setRefresh={setRefresh}
                    />
                </div>

                <div
                    className={`appointment-list-section ${
                        recordatoriosPendientes.length > 0 && citasDelDia.length > 0
                            ? "has-two-sections"
                            : "has-one-section"
                    }`}
                 >
                {duplicadosPendientes > 0 && (
                    <div className="aviso-duplicados">
                        <span>
                            ⚠️ {duplicadosPendientes === 1
                                ? "1 posible duplicado"
                                : `${duplicadosPendientes} posibles duplicados`}
                        </span>
                        <button
                            type="button"
                            className="aviso-duplicados__boton"
                            onClick={() => abrirPersonas("duplicados")}
                        >
                            Revisar
                        </button>
                    </div>
                 )}
                    
                 {recordatoriosPendientes.length > 0 && (
                    <section className="side-panel-block recordatorios-panel-block">
                        <h3>Recordatorios pendientes</h3>

                        <div className="side-panel-scroll">
                            <ul className="recordatorios-pendientes-list">
                                {recordatoriosPendientes.map((recordatorio) => (
                                   <li
                                        key={recordatorio.id}
                                        className={`recordatorio-pendiente-item recordatorio-${recordatorio.status}`}
                                    >
                                        <div>
                                            <strong>{recordatorio.paciente_nombre || "Paciente sin nombre"}</strong>

                                            <span className={`recordatorio-status-label status-${recordatorio.status}`}>
                                                {recordatorio.status === "enviado" ? "Enviado" : "Pendiente"}
                                            </span>
                                            <p>
                                                {recordatorio.fecha} · {recordatorio.start_time}
                                            </p>
                                            <p>
                                                Tel: {recordatorio.telefono_destino || "Sin teléfono"}
                                            </p>
                                        </div>

                                        <button
                                            className={`side-panel-action-button ${
                                                recordatorio.status === "enviado" ? "side-panel-action-button-resend" : ""
                                            }`}
                                            onClick={() => handleEnviarWhatsApp(recordatorio)}
                                        >
                                            {recordatorio.status === "enviado" ? "Reenviar" : "Enviar WhatsApp"}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </section>
                )}
                 <section className="side-panel-block citas-dia-panel-block">
                  <h3>Citas del Día</h3>
                    <div className="side-panel-scroll appointments-list">
                        {citasDelDia.length > 0 ? (
                            <ul>
                                {citasDelDia.map((cita, index) => (
                                    <li key={index} className={`appointment ${cita.status === "cancelada" ? "cancelada" : ""}`}>
                                        <div>
                                            <strong className="patient-name">{cita.paciente_nombre || ""}</strong> - 
                                            <span className="appointment-time">
                                                {cita.start_time ? `${cita.start_time} - ${cita.end_time || "Hora no registrada"}` : "Hora no registrada"}
                                            </span>
                                            <p className="appointment-details">
                                                {/* La agendó el paciente desde la página pública */}
                                                {cita.origen === "publico" && (
                                                    <>
                                                        <span className="etiqueta-en-linea">
                                                            🌐 En línea
                                                            {cita.primera_vez_declarada === true && " · Primera vez"}
                                                            {cita.primera_vez_declarada === false && " · Seguimiento"}
                                                        </span>{" "}
                                                    </>
                                                )}
                                                {cita.paciente
                                                    ? (cita.citasPrevias > 0 ? "Paciente Recurrente" : "Paciente Nuevo")
                                                    : cita.paciente_cita
                                                        ? <>
                                                            <span className="etiqueta-sin-alta">Pendiente de alta</span>
                                                            {cita.ficha_estado === "completada" && (
                                                                <>{" "}<span className="etiqueta-ficha-recibida">Ficha recibida</span></>
                                                            )}
                                                          </>
                                                        : "Cita Personal"}
                                                - <span className="status">{cita.status || "Pendiente"}</span>
                                            </p>
                                            <p className="appointment-details">Motivo: {cita.motivo && cita.motivo.trim() !== "" ? cita.motivo : "No registrado"}</p>
                                        </div>
                                        {/* 👇 Botón consulta */}
                                        {cita.paciente && (
                                            <button
                                                 className="side-panel-action-button"
                                                onClick={() => handleIniciarConsulta(cita.paciente)}
                                            >
                                                Iniciar Consulta
                                            </button>
                                        )}
                                        {/* 👇 Persona sin expediente: primero se completa el alta */}
                                        {!cita.paciente && cita.paciente_cita && (
                                            <button
                                                className="side-panel-action-button"
                                                onClick={() =>
                                                    navigate("/dashboard/alta-paciente", {
                                                        state: { pacienteCitaId: cita.paciente_cita },
                                                    })
                                                }
                                            >
                                                Completar alta
                                            </button>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="no-appointments">No hay citas programadas para hoy.</p>
                        )}
                    </div>
                  </section>
                </div>  
            </div>

            {mostrarModal && (
                <ModalCita
                    cita={citaSeleccionada}
                    onGuardar={() => {
                        setMostrarModal(false);
                        setRefresh(prev => !prev);
                    }}
                    onEliminar={() => { setMostrarModal(false); setRefresh(prev => !prev); }}
                    onCerrar={() => setMostrarModal(false)}
                />
            )}
            <ModalPersonasAgenda
                isOpen={mostrarPersonas}
                pestanaInicial={pestanaPersonas}
                onClose={() => setMostrarPersonas(false)}
                onUpdated={() => setRefresh(prev => !prev)}
            />

            {mostrarModalConfig && (
                <HorarioAtencionModal
            open={mostrarModalConfig}
            onClose={() => {
                setMostrarModalConfig(false);
                setRefresh(prev => !prev);   // << fuerza refetch del horario
            }}
            />
            )}
        </div>
    );
};

export default DashboardAgendamiento;
